import React, { useState } from "react";
import WadeLogo from "../../../../components/Icons/WadeLogo.svg";
import Input from "../../../Input/Input";
import AuthLayout from "../../AuthLayout";
import { useNavigate } from "react-router-dom";
import { getForgetPasswordToken } from "../../../../services/forgotPassword.service";

const ForgotPassword = () => {
  const navigate = useNavigate();

  const [emailUserID, setEmailUserID] = useState("");
  const [emailUserIDEmpty, setEmailUserIDEmpty] = useState(false);
  const [invalidEmailID, setInvalidEmailID] = useState(false);
  const [
    incorrectforgotPasswordInputChange,
    setIncorrectforgotPasswordInputChange,
  ] = useState(false);

  const validateEmail = () => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailUserID)) {
      return true;
    } else {
      return false;
    }
  };

  const onEmailUserIDChangeHandler = (evnt: any) => {
    if (invalidEmailID === true || emailUserIDEmpty === true) {
      setIncorrectforgotPasswordInputChange(true);
    }
    setEmailUserID(evnt.target.value);
  };

  const newPasswordCreationHandler = () => {
    setIncorrectforgotPasswordInputChange(false);
    if (emailUserID === "") {
      setInvalidEmailID(false);
      setEmailUserIDEmpty(true);
    } else {
      if (validateEmail()) {
        navigate("/reset_password", {
          state: { emailUserID: emailUserID },
        });
        getForgetPasswordToken(emailUserID);
      } else {
        setEmailUserIDEmpty(false);
        setInvalidEmailID(true);
      }
    }
  };

  return (
    <AuthLayout>
      <div className="tw-w-full tw-max-w-md tw-flex tw-flex-col tw-items-center">
        <img
          src={WadeLogo}
          alt="WADE Logo"
          className="tw-h-12 tw-mb-12"
        />
        <h2 className="tw-text-3xl tw-font-semibold tw-text-[#03234a] tw-mb-8">
          Forgot Password
        </h2>

        <div className="tw-w-full tw-mb-6">
          <Input
            id={
              incorrectforgotPasswordInputChange
                ? "tw-border-[#e88181] tw-text-[#e88181]"
                : invalidEmailID || emailUserIDEmpty
                  ? "tw-border-[#e88181] tw-text-[#e88181]"
                  : ""
            }
            className="tw-w-full"
            labelId="tw-text-[#03234a] tw-font-medium tw-mb-2"
            label="Email*"
            name="userID*"
            type="email"
            placeholder="Enter your registered Email ID"
            ariaDescribedBy="Enter your registered Email ID"
            value={emailUserID}
            maxlength={100}
            isDisabled={false}
            onChange={(e) => onEmailUserIDChangeHandler(e)}
          />

          {emailUserIDEmpty && (
            <div className="tw-text-[#e88181] tw-text-sm tw-mt-1">
              Email field cannot be empty. Please enter Email
            </div>
          )}
          {invalidEmailID && (
            <div className="tw-text-[#e88181] tw-text-sm tw-mt-1">
              Invalid Email. Please try again.
            </div>
          )}
        </div>

        <div className="tw-text-[#03234a] tw-text-sm tw-mb-6 tw-text-center">
          Password reset token would be shared to above email ID
        </div>

        <button
          type="button"
          onClick={newPasswordCreationHandler}
          className="tw-w-full tw-h-12 tw-bg-[#03234a] tw-text-[#d0fb56] tw-font-bold tw-rounded-md hover:tw-bg-[#021833] focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-[#03234a] tw-transition-all tw-shadow-md active:tw-transform active:tw-scale-[0.98]"
        >
          PROCEED
        </button>

        {/* Footer */}
        <div className="tw-absolute tw-bottom-6 tw-text-xs tw-text-[#03234a] tw-text-center tw-w-full">
          <span>©2023 All Rights Reserved</span>
          <span className="tw-mx-4">|</span>
          <a href="https://wadeinsight.com/privacy-policy/" target="_blank" className="tw-text-[#03234a] tw-no-underline hover:tw-underline">Privacy Policy</a>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
